var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PDF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15597",
    "data-name": "Rectangle 15597",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-download-pdf-4145746",
    transform: "translate(-13.613 -5.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49170",
    "data-name": "Path 49170",
    d: "M26.126,10.552l-4.5,5.185v2.188h1.1V16.5h5.008v-3.7H26.63v2.6H23.387l3.243-3.733h9.125v6.267h1.105V10.552Z",
    transform: "translate(-0.007)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49171",
    "data-name": "Path 49171",
    d: "M22.818,36.813h1.144c.481,0,1,.237.977.831-.019.535-.34.858-.977.858H22.818Zm-1.2-1v5.749h1.2V39.479h1.334A1.759,1.759,0,0,0,26,37.679a1.815,1.815,0,0,0-1.844-1.862Z",
    transform: "translate(0 -17.053)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49172",
    "data-name": "Path 49172",
    d: "M38.971,36.813h.89c1.168,0,1.6.758,1.6,1.818,0,1.082-.481,1.957-1.5,1.957h-1Zm-1.17-1v5.749h2.407a2.623,2.623,0,0,0,2.485-2.936,2.687,2.687,0,0,0-2.666-2.813Z",
    transform: "translate(-10.926 -17.053)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49173",
    "data-name": "Path 49173",
    d: "M55.91,35.817v5.749h1.2V39.142h2.527V38.128H57.114V36.821h2.892v-1Z",
    transform: "translate(-23.149 -17.053)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49174",
    "data-name": "Path 49174",
    d: "M57.852,50.1v6.639l-2.473,0-1.016,1.105,4.595,0V50.1Z",
    transform: "translate(-22.105 -26.696)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49175",
    "data-name": "Path 49175",
    d: "M21.625,56.1v5.781l4.6,0L25.2,60.783l-2.475,0V56.1Z",
    transform: "translate(-0.007 -30.746)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49176",
    "data-name": "Path 49176",
    d: "M37.68,57.974V62.8l-1.96-1.96-.782.78,3.294,3.3,3.294-3.3-.781-.78L38.785,62.8V57.974Z",
    transform: "translate(-8.993 -32.009)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.40d309895e461720956c4a7cc524e1ea.svg";
export { ForwardRef as ReactComponent };